import React from 'react';
import { Link } from 'react-router-dom';

const IndustrySolutions = () => {
  const industries = [
    {
      id: 'healthcare',
      name: 'Healthcare',
      icon: 'bi-heart-pulse',
      description: 'AI-powered patient care, medical diagnostics, and healthcare automation solutions for improved outcomes.',
      solutions: ['Patient Transport Automation', 'Medical Data Analytics', 'Healthcare Chatbots'],
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
      caseStudy: 'Healthcare Startup - 80% automated requests'
    },
    {
      id: 'transport',
      name: 'Transportation',
      icon: 'bi-truck',
      description: 'Intelligent logistics, fleet management, and transportation optimization systems for efficiency.',
      solutions: ['Fleet Management AI', 'Route Optimization', 'Predictive Maintenance'],
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
      caseStudy: 'Transportation Company - 15% sales increase'
    },
    {
      id: 'banking',
      name: 'Finance',
      icon: 'bi-bank',
      description: 'Financial analytics, fraud detection, and automated financial services for security.',
      solutions: ['Fraud Detection', 'Risk Assessment', 'Automated Trading'],
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
      caseStudy: 'Financial Services - 60-65% cost savings'
    },
    {
      id: 'retail',
      name: 'E-commerce',
      icon: 'bi-cart',
      description: 'Personalized shopping experiences, inventory optimization, and sales automation for growth.',
      solutions: ['Recommendation Engines', 'Inventory AI', 'Customer Service Bots'],
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
      caseStudy: 'E-commerce Platform - 25% conversion increase'
    }
  ];

  return (
    <section className="industry-solutions-section py-5" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(14, 165, 233, 0.1)',
      borderBottom: '1px solid rgba(14, 165, 233, 0.1)'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(14, 165, 233, 0.03) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(30, 64, 175, 0.02) 0%, transparent 50%)
        `,
        zIndex: 1
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h2 style={{
              fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
              fontWeight: '700',
              color: '#1e293b',
              marginBottom: '1rem',
              lineHeight: '1.2'
            }}>
              Expert in Transforming{' '}
              <span style={{
                background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Industries</span>
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#64748b',
              lineHeight: '1.6',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              We deliver AI solutions tailored to your industry's unique challenges and opportunities
            </p>
          </div>
        </div>

        <div className="row g-3 g-md-4">
          {industries.map((industry, index) => (
            <div key={industry.id} className="col-12 col-sm-6 col-lg-3">
              <div style={{
                background: '#ffffff',
                border: '2px solid #94a3b8',
                borderRadius: 'clamp(16px, 3vw, 20px)',
                padding: 'clamp(1.5rem, 4vw, 2rem)',
                height: '100%',
                minHeight: 'clamp(450px, 70vw, 600px)',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
                display: 'flex',
                flexDirection: 'column'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.borderColor = 'rgba(14, 165, 233, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
                e.currentTarget.style.borderColor = '#94a3b8';
              }}>
                {/* Responsive Grid Layout */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 'clamp(0.75rem, 2vw, 1rem)',
                  height: '100%'
                }}>
                  {/* Row 1: Icon + Title */}
                  <div style={{
                    minHeight: 'clamp(50px, 10vw, 60px)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'clamp(0.75rem, 2vw, 1rem)'
                  }}>
                    <div style={{
                      width: 'clamp(35px, 7vw, 45px)',
                      height: 'clamp(35px, 7vw, 45px)',
                      background: industry.gradient,
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)',
                      flexShrink: 0
                    }}>
                      <i className={`bi ${industry.icon}`} style={{
                        color: 'white',
                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)'
                      }}></i>
                    </div>
                    <h3 style={{
                      fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                      fontWeight: '700',
                      color: '#1e293b',
                      lineHeight: '1.3',
                      margin: 0
                    }}>
                      {industry.name}
                    </h3>
                  </div>

                  {/* Row 2: Descriptions */}
                  <div style={{
                    minHeight: 'clamp(80px, 15vw, 100px)',
                    display: 'flex',
                    alignItems: 'flex-start'
                  }}>
                    <p style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.85rem)',
                      color: '#64748b',
                      lineHeight: '1.5',
                      margin: 0
                    }}>
                      {industry.description}
                    </p>
                  </div>

                  {/* Row 3: Key Solutions Heading */}
                  <div style={{
                    minHeight: 'clamp(30px, 6vw, 35px)',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <h4 style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.85rem)',
                      fontWeight: '600',
                      color: '#374151',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      margin: 0
                    }}>
                      Key Solutions
                    </h4>
                  </div>

                  {/* Row 4: Solutions List */}
                  <div style={{
                    minHeight: 'clamp(90px, 18vw, 120px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 'clamp(0.375rem, 1vw, 0.5rem)'
                    }}>
                      {industry.solutions.map((solution, idx) => (
                        <div key={idx} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'clamp(0.375rem, 1vw, 0.5rem)',
                          fontSize: 'clamp(0.75rem, 2vw, 0.85rem)',
                          color: '#64748b',
                          minHeight: 'clamp(20px, 4vw, 25px)',
                          lineHeight: '1.3'
                        }}>
                          <i className="bi bi-check-circle-fill" style={{
                            color: '#10b981',
                            fontSize: 'clamp(0.6rem, 1.5vw, 0.7rem)',
                            flexShrink: 0
                          }}></i>
                          {solution}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Row 5: Success Story Box */}
                  <div style={{
                    minHeight: 'clamp(80px, 15vw, 100px)',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      background: 'rgba(14, 165, 233, 0.05)',
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      padding: 'clamp(0.75rem, 2vw, 1rem)',
                      border: '2px solid rgba(14, 165, 233, 0.4)',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'clamp(0.375rem, 1vw, 0.5rem)',
                        marginBottom: 'clamp(0.375rem, 1vw, 0.5rem)'
                      }}>
                        <i className="bi bi-graph-up-arrow" style={{
                          color: '#10b981',
                          fontSize: 'clamp(0.8rem, 2vw, 1rem)'
                        }}></i>
                        <span style={{
                          fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                          fontWeight: '600',
                          color: '#1e293b'
                        }}>
                          Success Story
                        </span>
                      </div>
                      <p style={{
                        fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                        color: '#64748b',
                        margin: 0,
                        lineHeight: '1.4'
                      }}>
                        {industry.caseStudy}
                      </p>
                    </div>
                  </div>
                </div>

                {/* CTA - Pushed to bottom */}
                <div style={{ marginTop: 'auto', paddingTop: 'clamp(0.75rem, 2vw, 1rem)' }}>
                  <Link
                    to={`/industries/${industry.id}`}
                    style={{
                      background: industry.gradient,
                      border: 'none',
                      color: '#ffffff',
                      padding: 'clamp(0.6rem, 2vw, 0.75rem) clamp(1.2rem, 3vw, 1.5rem)',
                      borderRadius: 'clamp(8px, 2vw, 10px)',
                      fontWeight: '600',
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 'clamp(0.375rem, 1vw, 0.5rem)',
                      width: '100%',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                      minHeight: 'clamp(40px, 8vw, 44px)'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                    }}
                  >
                    Explore Solutions
                    <i className="bi bi-arrow-right" style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)'
                    }}></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Industries CTA */}
        <div className="row justify-content-center mt-5">
          <div className="col-12 col-md-6 col-lg-3 text-center">
            <Link to="/industries" style={{
              background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
              border: 'none',
              color: '#ffffff',
              padding: '1.2rem 3rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 25px rgba(14, 165, 233, 0.4)',
              position: 'relative',
              overflow: 'hidden',
              width: '100%',
              maxWidth: '300px'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 12px 35px rgba(14, 165, 233, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 25px rgba(14, 165, 233, 0.4)';
            }}>
              <i className="bi bi-grid-3x3-gap" style={{ fontSize: '1.2rem' }}></i>
              View All Industries
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustrySolutions;
